module.exports = __webpack_public_path__ + "img/union4.302894db.png";